import type { SidebarUser } from '@lilara/ui-web'
import { HubtypeUser } from 'src/app/models/hubtype-user'

export type SidebarUserStatus = 'online' | 'away' | 'offline'

export interface UserMenuItem {
  id: string
  label: string
  icon?: string
  iconPrefix?: string
  emphasis?: string
  href?: string
  dividerBefore?: boolean
  keepOpen?: boolean
}

export const USER_MENU_ITEM_IDS = {
  status: 'status',
  userSettings: 'user-settings',
  logOut: 'log-out',
} as const

export function mapUserStatus(me: HubtypeUser): SidebarUserStatus {
  if (me.isAway) return 'away'
  if (me.isOffline) return 'offline'
  return 'online'
}

export function buildSidebarUser(
  me: HubtypeUser,
  status: SidebarUserStatus = mapUserStatus(me),
  translate: (key: string) => string = key => key
): SidebarUser {
  return {
    name:
      me.name || me.email || translate('shared.lilaraSidebar.user.defaultName'),
    secondaryLabel: me.email || undefined,
    avatarUrl: me.pic || undefined,
    status,
  }
}

export function buildUserMenuItems(
  status: SidebarUserStatus,
  translate: (key: string) => string = key => key
): UserMenuItem[] {
  const emphasis =
    status === 'online'
      ? translate('shared.lilaraSidebar.user.away')
      : translate('shared.lilaraSidebar.user.active')
  return [
    {
      id: USER_MENU_ITEM_IDS.status,
      label: translate('shared.lilaraSidebar.user.setYourselfAs'),
      emphasis,
      keepOpen: true,
    },
    {
      id: USER_MENU_ITEM_IDS.userSettings,
      label: translate('shared.lilaraSidebar.user.userSettings'),
      href: '/profile',
      dividerBefore: true,
    },
    {
      id: USER_MENU_ITEM_IDS.logOut,
      label: translate('shared.lilaraSidebar.user.logout'),
    },
  ]
}
